import { Injectable } from '@angular/core';

import { InstallationItem, InstallationItemGatewayDevice, Subscription } from '@vi-iot/client';

import { BookingDashboardDevice, BookingSubscription, Platform, VkOrgCountry } from '@store';

import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BookingService {
  constructor(private translateService: TranslateService) {}

  getFullDetailsOfSubscribedInstallations(
    subscriptions: Subscription[],
    installations: InstallationItem[]
  ): BookingSubscription[] {
    return subscriptions.map((singleSubscription) => {
      const installation = installations.find((inst) =>
        inst.gateways.find((gateway) =>
          gateway.devices.find((dev) => dev.serial === singleSubscription.boilerId)
        )
      );
      const device: InstallationItemGatewayDevice = installation?.gateways
        .map((gateway) => gateway.devices.find((dev) => dev.serial === singleSubscription.boilerId))
        .filter(Boolean)[0];
      const mappedSubscription: BookingSubscription = {
        ...singleSubscription,
        ownerName: installation?.ownerName,
        marketingName: device?.marketingName,
        deviceImageUrl: device?.imageUrl ? device?.imageUrl : '',
        installationLocation: installation?.location,
        installationId: installation?.id,
        gatewaySerial: device?.gatewaySerial,
        registeredInstallation: !!installation,
      };

      return mappedSubscription;
    });
  }

  static canBeUsedBundlingPackage(
    platform: Platform,
    isOnWhiteList: boolean,
    vkOrg: string
  ): boolean {
    if (vkOrg.includes(VkOrgCountry.Germany) || vkOrg.includes(VkOrgCountry.Belgium)) {
      return platform === Platform.E3;
    } else {
      return isOnWhiteList && platform !== Platform.None;
    }
  }

  getDeviceTitle(device: BookingDashboardDevice): string {
    return device.marketingName
      ? device.marketingName
      : `${this.translateService.instant('+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF')} ${
          device.ownerName
        }`;
  }

  getRouterLinkAfterPurchase(devices: BookingDashboardDevice[]): string {
    if (devices.length === 1) {
      return `/installations/${devices[0].installationId}`;
    } else {
      return '/installations';
    }
  }
}
